<template>
    <div style="background-color: white">
        <br>
        <h3 style="text-align: center">บันทึกข้อความจากเฮีย / คุณมด</h3>
        <nav class="navbar navbar-expand-lg navbar-light">
            <div class="ml-auto">
                <form v-on:keypress.enter.prevent="getMessageData(1)"
                      class="form-inline my-2 my-lg-0">
                    <button type="button" class="btn btn-warning" @click="clearFormData">
                        <icon name="plus"></icon>
                       เพิ่มใบบันทึกข้อความ
                    </button>
                </form>
            </div>
        </nav>
        <div class="table-responsive">
            <table class="table table-bordered">
                <thead>
                <tr>
                    <th>วันที่</th>
                    <th>ข้อความ</th>
                    <th>ผู้สร้าง</th>
                    <th>ผู้แก้ไข</th>
                    <th>แก้ไข / ลบ</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="data in table_data">
                    <td>{{data.created_at | moment('DD/MM/YYYY')}}</td>
                    <td>{{data.message}}</td>
                    <td>{{data.user ? data.user.name : ''}}</td>
                    <td>{{data.update_user ? data.update_user.name : ''}}</td>
                    <td>
                        <a @click="showMessageData(data.id)">
                            <icon name="pencil-alt"></icon>
                        </a>&nbsp;
                        <a @click="showDeleteDataModal(data.id)">
                            <icon name="trash"></icon>
                        </a>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
        <b-modal hide-header hide-footer ref="add_data">
            <record-message-modal @submit="saveMessageData"></record-message-modal>
        </b-modal>
        <b-modal hide-header hide-footer ref="delete_data">
            <delete-confirm-modal @submit="deleteMessageData"></delete-confirm-modal>
        </b-modal>
    </div>
</template>

<script>
    import RecordMessageModal from "./RecordMessageModal";
    import DeleteConfirmModal from "../Utility/DeleteConfirmModal";
    export default {
        name: "RecordMessage",
        components: {DeleteConfirmModal, RecordMessageModal},
        computed : {

        },
        data(){
          return{
              delete_id : '',
              table_data : [],
              dataPaginate : {
                  current_page :1,
                  from : 1,
                  last_page : 1,
                  per_page : 1,
                  total : 1,
                  to : 1
              },
          }
        },
        created() {
            this.getMessageData(1);
        },
        methods:{
            getMessageData(page){
                this.$store.dispatch("Dashboard/recordMessage",{
                    page,
                }).then(res=>{
                    this.table_data = res.data;
                    this.dataPaginate = {
                        current_page :res.current_page,
                        from : res.from,
                        last_page : res.last_page,
                        per_page : res.per_page,
                        total : res.total,
                        to : res.to
                    }
                })
            },
            showAddDataModal(){
                this.$refs.add_data.show();
            },
            hideAddDataModal(){
                this.$refs.add_data.hide();
            },
            showDeleteDataModal(id){
                this.delete_id = id;
                this.$refs.delete_data.show();
            },
            hideDeleteDataModal(){
                this.$refs.delete_data.hide();
            },
            saveMessageData(value){
                if(value){
                    this.$store.dispatch("Dashboard/saveRecordMessage",{
                        id : value.id,
                        data : value,
                    }).then(()=>{
                        this.getMessageData();
                    })
                }
                this.hideAddDataModal();
            },
            showMessageData(id){
                this.$store.dispatch("Dashboard/showRecordMessage",id).then(()=>{
                    this.showAddDataModal();
                })
            },
            clearFormData(){
                this.$store.dispatch("Dashboard/clearFormRecordMessage").then(()=>{
                    this.showAddDataModal();
                })
            },
            deleteMessageData(value){
                if(value){
                    this.$store.dispatch("Dashboard/deleteRecordMessage",this.delete_id).then(()=>{
                        alert('ลบรายการสำเร็จ');
                        this.getMessageData(this.dataPaginate.current_page);
                        this.hideDeleteDataModal();
                    }).catch(()=>{
                        alert('ลบไม่รายการสำเร็จ');
                    })
                }else{
                    this.hideDeleteDataModal();
                }
            }
        },
    }
</script>

<style scoped>

</style>
